import React from "react";

const Button = (props) => {
  const {title, className,children, ...other} = props;
    return title && (
      <button className={`btn ${className || ''}`} type={'button'} {...other}>
        <span className="position-relative z-1">{title}</span>
        {children}
      </button>
    )
}

export default Button
